module.exports = __webpack_public_path__ + "img/AuSaturday_Ad1.f36376a5.png";